// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projects-page {
  min-height: 100vh;
  background: var(--bg-primary);
}

/* Dark theme support for projects page */
[data-theme="dark"] .projects-page {
  background: var(--bg-primary);
}

.projects-main {
  padding: 8rem 0 2rem 0;
}

.projects-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.projects-header {
  margin-bottom: 3rem;
}

.projects-title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.projects-emoji {
  font-size: 3rem;
  animation: bounce 2s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.projects-title {
  font-size: 3rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  background: linear-gradient(135deg, #8B4513, #D2B48C);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.projects-subtitle {
  font-size: 1.2rem;
  color: #495057;
  line-height: 1.6;
  max-width: 600px;
  margin: 0;
}

.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* Dark theme support */

[data-theme="dark"] .projects-title {
  background: linear-gradient(135deg, #D2B48C, #F5DEB3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-theme="dark"] .projects-subtitle {
  color: #ecf0f1;
}

/* Responsive design */
@media (max-width: 1200px) {
  .projects-grid {
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .projects-main {
    padding: 7rem 0 2rem 0;
  }
  
  .projects-container {
    padding: 0 0.5rem;
  }
  
  .projects-title {
    font-size: 2rem;
  }
  
  .projects-emoji {
    font-size: 2rem;
  }
  
  .projects-subtitle {
    font-size: 1.1rem;
  }
  
  .projects-header {
    margin-bottom: 2rem;
  }
  
  .projects-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 0;
  }
}

@media (max-width: 480px) {
  .projects-main {
    padding: 6rem 0 2rem 0;
  }
  
  .projects-title {
    font-size: 1.75rem;
  }
  
  .projects-emoji {
    font-size: 1.75rem;
  }
  
  .projects-subtitle {
    font-size: 1rem;
  }
  
  .projects-header {
    margin-bottom: 1.5rem;
  }
  
  .projects-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

/* Animation for project cards */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.projects-grid .project-card {
  animation: fadeInUp 0.6s ease-out;
  animation-fill-mode: both;
}

.projects-grid .project-card:nth-child(1) { animation-delay: 0.1s; }
.projects-grid .project-card:nth-child(2) { animation-delay: 0.2s; }
.projects-grid .project-card:nth-child(3) { animation-delay: 0.3s; }
.projects-grid .project-card:nth-child(4) { animation-delay: 0.4s; }
.projects-grid .project-card:nth-child(5) { animation-delay: 0.5s; }
.projects-grid .project-card:nth-child(6) { animation-delay: 0.6s; }
.projects-grid .project-card:nth-child(7) { animation-delay: 0.7s; }
.projects-grid .project-card:nth-child(8) { animation-delay: 0.8s; }
.projects-grid .project-card:nth-child(9) { animation-delay: 0.9s; }
.projects-grid .project-card:nth-child(10) { animation-delay: 1.0s; }
.projects-grid .project-card:nth-child(11) { animation-delay: 1.1s; }
.projects-grid .project-card:nth-child(12) { animation-delay: 1.2s; }
.projects-grid .project-card:nth-child(13) { animation-delay: 1.3s; }
.projects-grid .project-card:nth-child(14) { animation-delay: 1.4s; }
.projects-grid .project-card:nth-child(15) { animation-delay: 1.5s; }
`, "",{"version":3,"sources":["webpack://./src/pages/ProjectsPage/ProjectsPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,yCAAyC;AACzC;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;;AAEvB;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,2DAA2D;IAC3D,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,4CAA4C,qBAAqB,EAAE;AACnE,4CAA4C,qBAAqB,EAAE;AACnE,4CAA4C,qBAAqB,EAAE;AACnE,4CAA4C,qBAAqB,EAAE;AACnE,4CAA4C,qBAAqB,EAAE;AACnE,4CAA4C,qBAAqB,EAAE;AACnE,4CAA4C,qBAAqB,EAAE;AACnE,4CAA4C,qBAAqB,EAAE;AACnE,4CAA4C,qBAAqB,EAAE;AACnE,6CAA6C,qBAAqB,EAAE;AACpE,6CAA6C,qBAAqB,EAAE;AACpE,6CAA6C,qBAAqB,EAAE;AACpE,6CAA6C,qBAAqB,EAAE;AACpE,6CAA6C,qBAAqB,EAAE;AACpE,6CAA6C,qBAAqB,EAAE","sourcesContent":[".projects-page {\n  min-height: 100vh;\n  background: var(--bg-primary);\n}\n\n/* Dark theme support for projects page */\n[data-theme=\"dark\"] .projects-page {\n  background: var(--bg-primary);\n}\n\n.projects-main {\n  padding: 8rem 0 2rem 0;\n}\n\n.projects-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n.projects-header {\n  margin-bottom: 3rem;\n}\n\n.projects-title-section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.projects-emoji {\n  font-size: 3rem;\n  animation: bounce 2s ease-in-out infinite;\n}\n\n@keyframes bounce {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-10px); }\n}\n\n.projects-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin: 0;\n  background: linear-gradient(135deg, #8B4513, #D2B48C);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.projects-subtitle {\n  font-size: 1.2rem;\n  color: #495057;\n  line-height: 1.6;\n  max-width: 600px;\n  margin: 0;\n}\n\n.projects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n/* Dark theme support */\n\n[data-theme=\"dark\"] .projects-title {\n  background: linear-gradient(135deg, #D2B48C, #F5DEB3);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n[data-theme=\"dark\"] .projects-subtitle {\n  color: #ecf0f1;\n}\n\n/* Responsive design */\n@media (max-width: 1200px) {\n  .projects-grid {\n    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n    gap: 1.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .projects-main {\n    padding: 7rem 0 2rem 0;\n  }\n  \n  .projects-container {\n    padding: 0 0.5rem;\n  }\n  \n  .projects-title {\n    font-size: 2rem;\n  }\n  \n  .projects-emoji {\n    font-size: 2rem;\n  }\n  \n  .projects-subtitle {\n    font-size: 1.1rem;\n  }\n  \n  .projects-header {\n    margin-bottom: 2rem;\n  }\n  \n  .projects-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n    padding: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .projects-main {\n    padding: 6rem 0 2rem 0;\n  }\n  \n  .projects-title {\n    font-size: 1.75rem;\n  }\n  \n  .projects-emoji {\n    font-size: 1.75rem;\n  }\n  \n  .projects-subtitle {\n    font-size: 1rem;\n  }\n  \n  .projects-header {\n    margin-bottom: 1.5rem;\n  }\n  \n  .projects-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n/* Animation for project cards */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.projects-grid .project-card {\n  animation: fadeInUp 0.6s ease-out;\n  animation-fill-mode: both;\n}\n\n.projects-grid .project-card:nth-child(1) { animation-delay: 0.1s; }\n.projects-grid .project-card:nth-child(2) { animation-delay: 0.2s; }\n.projects-grid .project-card:nth-child(3) { animation-delay: 0.3s; }\n.projects-grid .project-card:nth-child(4) { animation-delay: 0.4s; }\n.projects-grid .project-card:nth-child(5) { animation-delay: 0.5s; }\n.projects-grid .project-card:nth-child(6) { animation-delay: 0.6s; }\n.projects-grid .project-card:nth-child(7) { animation-delay: 0.7s; }\n.projects-grid .project-card:nth-child(8) { animation-delay: 0.8s; }\n.projects-grid .project-card:nth-child(9) { animation-delay: 0.9s; }\n.projects-grid .project-card:nth-child(10) { animation-delay: 1.0s; }\n.projects-grid .project-card:nth-child(11) { animation-delay: 1.1s; }\n.projects-grid .project-card:nth-child(12) { animation-delay: 1.2s; }\n.projects-grid .project-card:nth-child(13) { animation-delay: 1.3s; }\n.projects-grid .project-card:nth-child(14) { animation-delay: 1.4s; }\n.projects-grid .project-card:nth-child(15) { animation-delay: 1.5s; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
